"usestrict";
angular.module("internal.exams").controller("InternalExamAutomationAlertType", ["$scope",
    "$stateParams",
    "$state",
    "EXAlertTypes",
    "$window",
    function ($scope, $stateParams, $state, EXAlertTypes, $window) {
        $scope.loading = true;
        $scope.AlertType = {};
        $scope.saveMessage = $stateParams.saveMessage;
        $window.scrollTo(0, 0);

        if ($stateParams.examAlertTypeID != null) {
            EXAlertTypes.getalerttype($stateParams.examAlertTypeID).then(function (AlertType) {
                $scope.AlertType = AlertType;
                $scope.loading = false;
            });
        }

        $scope.save = function () {
            $scope.saving = true;
            EXAlertTypes.save($scope.AlertType).then(function (AlertType) {
                $scope.saving = false;
                if (AlertType != null) {
                    $state.go("internal.exams.administrative.alerttype", { examAlertTypeID: AlertType.id, saveMessage: "Record updated successfully" });
                } else {
                    $scope.saveMessage = "Error: Save failed";
                    $window.scrollTo(0, 0);
                }
            });
        };

        $scope.delete = function () {
            $scope.deleting = true;
            if ($scope.AlertType.numexamtypes != null && $scope.AlertType.numexamtypes > 0) {
                $scope.saveMessage = "Please remove the associated alert types from any exam type trigger(s) in order for deletion";
                $window.scrollTo(0, 0);
                $scope.deleting = false;
            } else {
                if (window.confirm("Are you sure you want to delete this alert type?")) {
                    EXAlertTypes.delete($scope.AlertType.id).then(function () {
                        $scope.deleting = false;
                        $state.go("internal.exams.administrative.alerttypes", {}, {
                            reload: "internal.exams.administrative.alerttypes"
                        });
                    });
                } else {
                    $scope.deleting = false;
                }
            }
        };
    }]);